import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { titleize, unescapeHTML } from 'underscore.string';
import { withTranslation } from 'react-i18next';
import { getShipmentPreferenceType } from 'helpers/shipments';
import CustomerSearchWithPreferences from 'components/site/customer-search-with-preferences';
import { getCarrierPreferencesByType, getPreferredCarrierList, } from 'utils/CarrierPreferencesUtils';
import CustomerSearch from 'components/site/customer-search';
import { sluggify } from 'utils/localization/utils';
import { areShipmentsHaveSameShipper } from 'components/modules/shipments/utils';
import CustomDropdown from 'components/v2/dropdowns/CustomDropdown';
const JobList = (props) => {
    if (!props.jobs) {
        return null;
    }
    const { t, isShipper } = props;
    return (React.createElement("div", null,
        React.createElement("div", { className: "flex p-2" },
            React.createElement("div", { className: "w-1/6" },
                React.createElement("b", null, "#")),
            React.createElement("div", { className: "w-1/4" },
                React.createElement("b", null, titleize(t('SHIPMENT_ID')))),
            React.createElement("div", { className: "w-1/2" },
                React.createElement("b", null, titleize(t('CURRENT_SHIPMENT_TYPE', { type: t(sluggify(props.type)) })))),
            React.createElement("div", { className: "w-1/6" },
                React.createElement("b", null, !isShipper && titleize(t('REMOVE'))))),
        props.jobs.map((job, index) => {
            const className = classnames({
                'border-solid': true,
                'border-t': true,
                'border-grey-light': true,
                'p-2': true,
                flex: true,
                'bg-grey-lightest': index % 2 === 0,
            });
            let name = unescapeHTML(job[`${props.type}_name`]);
            if (isShipper) {
                name = job.external_carrier_name || t('NONE');
            }
            return (React.createElement("div", { className: className, key: job._id },
                React.createElement("div", { className: "w-1/6" },
                    index + 1,
                    "."),
                React.createElement("div", { className: "w-1/4" }, job.shipment_id),
                React.createElement("div", { className: "w-1/2" }, name),
                React.createElement("div", { className: "w-1/6 text-grey-light hover:text-grey-darker" }, !isShipper && (React.createElement("button", { className: "font-bold", disabled: isShipper, onClick: () => props.onRemove(job) },
                    React.createElement("i", { className: "fa fa-remove" }))))));
        })));
};
JobList.propTypes = {
    jobs: PropTypes.array,
    type: PropTypes.string,
    isShipper: PropTypes.bool,
};
class ChangeUser extends Component {
    constructor(props) {
        super(props);
        this.handleJobRemove = (job) => this.props.onRemoveJob(job);
        this.handleSelectUser = (item, value) => this.props.onSelectUser(item, value);
        this.handleCarrierSelect = (item) => {
            if (item.value === 'cargomatic_network_carrier') {
                const carrier = {
                    name: 'Cargomatic Network Carrier',
                    _id: null,
                    status: 'Trained',
                    _type: 'Carrier',
                };
                this.setState({ selectedCarrier: item });
                return this.props.onSelectUser(null, carrier);
            }
            this.props.onSelectUser(null, item);
            this.setState({ selectedCarrier: item });
        };
        this.renderShipperCarrierSelect = () => {
            const { t } = this.props;
            const { preferredCarrierList, selectedCarrier } = this.state;
            const carrierList = preferredCarrierList.map((c) => {
                return {
                    name: c.name,
                    value: c,
                };
            });
            carrierList.push({
                name: 'Cargomatic Network Carrier',
                value: 'cargomatic_network_carrier',
            });
            const selected = selectedCarrier || t('SELECT_CARRIER');
            return (React.createElement("div", { className: "w-32 mt-4" },
                React.createElement(CustomDropdown, { value: selected, options: carrierList, onChange: this.handleCarrierSelect, nameKey: "name", valueKey: "value", label: t('SELECT_CARRIER'), buttonWidth: "w-64" })));
        };
        this.state = {
            carrierPreferences: null,
            preferredCarrierList: [],
            selectedCarrier: null,
        };
    }
    async componentDidMount() {
        const shipment = this.props.jobs.length
            ? this.props.jobs[0]
            : this.props.jobs;
        if (!shipment) {
            return;
        }
        const { shipment_type: shipmentType } = shipment;
        const preferenceType = getShipmentPreferenceType(shipmentType);
        if (!preferenceType) {
            return;
        }
        if (this.props.isShipper) {
            const preferredCarrierList = await getPreferredCarrierList(shipment.shipper.id || shipment.shipper._id, preferenceType);
            return this.setState({ preferredCarrierList });
        }
        if (areShipmentsHaveSameShipper(this.props.jobs)) {
            const carrierPreferences = await getCarrierPreferencesByType(shipment.shipper.id || shipment.shipper._id, preferenceType);
            this.setState({ carrierPreferences });
        }
    }
    renderAdminUserSelect(jobs, type, t, customerSearchType, showSearchWithPreferences) {
        const placeholderText = titleize(t('TYPE_SEARCH', { type: t(sluggify(type)) }));
        return (React.createElement("div", { className: "mt-4" },
            React.createElement("p", { className: "font-bold" }, `2. ${t('SELECT_A_TYPE_WITH_TYPE', {
                type: t(sluggify(type), { count: 1 }),
            })}`),
            showSearchWithPreferences ? (React.createElement(CustomerSearchWithPreferences, { id: "carrier-search-input", clearOnSelect: false, type: "carriers", assignField: true, onSelect: this.handleSelectUser, placeholder: t('SEARCH_FOR_TYPE', {
                    type: t(sluggify(type), { count: 1 }),
                }), carrierPreferences: this.state.carrierPreferences })) : (React.createElement(CustomerSearch, { type: customerSearchType, onSelect: this.handleSelectUser, placeholder: placeholderText }))));
    }
    render() {
        const { jobs, type, t } = this.props;
        if (!jobs || jobs.length === 0) {
            return (React.createElement("div", { className: "text-sm p-2" }, t('NO_SHIPMENTS_AVAILABLE_TO_UPDATE')));
        }
        const customerSearchType = `${type}s`;
        const showSearchWithPreferences = areShipmentsHaveSameShipper(jobs) &&
            type === 'carrier' &&
            (jobs[0].shipment_type === 'drayage' ||
                jobs[0].shipment_type === 'shorthaul' ||
                jobs[0].shipment_type === 'longhaul');
        return (React.createElement("div", { className: "text-sm" },
            React.createElement("div", null,
                React.createElement("p", null, t('CHANGING_SHIPMENT_TYPE_WILL_CAUSE_REPRICE_TIP', {
                    type: t(sluggify(type)),
                }))),
            React.createElement("div", { className: "mt-4" }, jobs.length > 0 && (React.createElement("div", null,
                React.createElement("p", { className: "font-bold" }, t('VERIFY_LIST_OF_SHIPMENTS')),
                React.createElement(JobList, { jobs: jobs, type: type, onRemove: this.handleJobRemove, t: t, isShipper: this.props.isShipper })))),
            this.props.isShipper
                ? this.renderShipperCarrierSelect()
                : this.renderAdminUserSelect(jobs, type, t, customerSearchType, showSearchWithPreferences)));
    }
}
ChangeUser.propTypes = {
    type: PropTypes.oneOf(['shipper', 'carrier', 'consignee']),
    jobs: PropTypes.array,
    onRemoveJob: PropTypes.func.isRequired,
    onSelectUser: PropTypes.func.isRequired,
    isShipper: PropTypes.bool,
};
ChangeUser.defaultProps = {
    jobs: [],
    isShipper: false,
};
export default withTranslation()(ChangeUser);
